import MyselfLogo from "../../assets/myself_logo.png"
import DadBirthdayLogo from "../../assets/dad_birthday_logo1.png"
import MomBirthdayLogo from "../../assets/mom_birthday_logo.png"
import SisterGiftLogo from "../../assets/sister_gift_logo.png"
import BrotherGiftLogo from "../../assets/brother_gift_logo1.png"
import AnniversaryGiftLogo from "../../assets/anniversary_gift1.png"

// Moment cards row
const momentCards = [
  { label: "For myself", bg: "bg-[#ddeeff]", imgSrc: MyselfLogo },
  { label: "For our anniversary", bg: "bg-[#ffe0f0]", imgSrc: AnniversaryGiftLogo },
  { label: "For mom's birthday", bg: "bg-[#eedeff]", imgSrc: MomBirthdayLogo },
  { label: "For dad's day", bg: "bg-[#fff3d6]", imgSrc: DadBirthdayLogo },
  { label: "For my sister", bg: "bg-[#d6f5e3]", imgSrc: SisterGiftLogo },
  { label: "For my brother", bg: "bg-[#e8f0ff]", imgSrc: BrotherGiftLogo },
];

export default function MomentsSection() {
  return (
    <section className="bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        
        {/* label */}
        <div className="flex items-center justify-center gap-3 mb-4">
          <span className="text-[#4C42FD] text-sm">✦</span>
          <span className="text-[11px] font-bold font-montserrat uppercase tracking-[0.2em] text-[#4C42FD]">
            For Every Moment
          </span>
          <span className="text-[#4C42FD] text-sm">✦</span>
        </div>

        {/* heading */}
        <h2 className="text-center font-montserrat text-3xl font-black text-[#0d1f3c] sm:text-4xl leading-snug mb-10">
          Not just for you,
          <br />
          for every moment that matters
        </h2>

        {/* cards */}
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {momentCards.map((card) => (
            <div
              key={card.label}
              className="group relative flex flex-col overflow-hidden rounded-xl border border-[#e0ecff] shadow-sm md:hover:shadow-md transition-all duration-200"
            >
              <div className={`${card.bg} h-[110px] w-full flex items-center justify-center`}>
                <img
                  src={card.imgSrc}
                  alt={card.label}
                  className="h-full w-full object-cover"
                />
              </div>

              <div className="bg-white px-2 py-2 text-center text-[13px] font-semibold font-montserrat text-[#0d1f3c] leading-tight">
                {card.label}
              </div>
            </div>
          ))}
        </div>

        {/* bottom tagline */}
        <p className="mt-12 text-center font-montserrat text-2xl sm:text-2xl lg:text-2xl font-black leading-snug text-[#0d1f3c]">
  <span className="mr-2">💜</span>
  Whatever it is — your money is ready.
</p>

    
      </div>
    </section>
  );
}